<template>
  <div id="bodyContainer" @click="showLang = false" class="page-home2 slides scroll animated smooth  smoothScroll animateOnEvent noPreload">
    <!-- Panel Top #04 -->
    <nav class="panel top">
      <div class="sections desktop">
        <div class="home-menu">
          <div class="left">
            <a target="_blank" href="https://firecat.finance" class="logo flex-center" title="FIRECAT">
              <img src="../../assets/imgs/logo.png" alt="">
            </a>
          </div>
          <div class="center">
            <ul class="menu margin-right-3">
              <li>
                <a target="_blank" href="https://app.firecat.finance/">
                  <span>{{$t('home.FUND')}}</span>
                </a>
              </li>
              <li>
                <a target="_blank" href="https://app.firecat.finance/vaultDividend">
                  <span>{{$t('home.VAULTDIVIDEND')}}</span>
                </a>
              </li>
              <li>
                <a target="_blank" href="https://app.firecat.finance/vault">
                  <span>{{$t('home.VAULT')}}</span>
                </a>
              </li>
              <li>
                <a target="_bank" href="https://app.firecat.finance/nft">
                  <span>NFT</span>
                </a>
              </li>
              <li>
                <a target="_bank" href="https://app.firecat.finance/node">
                  <span>{{$t('home.node')}}</span>
                </a>
              </li>
              <li>
                <a target="_bank" href="https://firecat-finance-1.gitbook.io/fire-cat-finance">
                  <span>{{$t('home.docs')}}</span>
                </a>
              </li>
              <li>
                <a @click="showPop = true" href="#">
                  <span>DAO</span>
                </a>
              </li>
            </ul>
            <div class="menu-lan" @click.stop="showLang = !showLang">
              <div class="lan-text">
                <div>{{lan.toUpperCase()}}</div>
                <img :class="{'active':showLang}" src="../../assets/imgs/down-icon.png" alt="">
              </div>
              <div class="lan-list" v-if="showLang">
                <div @click="setLan('en')" :class="{'active':lan === 'en'}">EN</div>
                <div @click="setLan('zh')" :class="{'active':lan === 'zh'}">ZH</div>
              </div>
            </div>
          </div>
          <div class="right">
            <a class="getapp bgc-blue" data-popup-id="arche-intro" target="_bank" href="https://app.firecat.finance" data-popup-focus-input="username">
              <img src="../../assets/imgs/white_logo.png" alt="Logo">
              <div>{{$t('home.launchDapp')}}</div>
            </a>
          </div>
        </div>
      </div>
    </nav>

    <!-- Slide 1 (#20) -->
    <section class="slide slide1">
      <div class="content">
        <div class="container">
          <div class="wrap">
            <div class="left toLeft opener">
              <div class="info ae-2 fromLeft">
                <img class="left-img" src="../../assets/imgs/nft.png" alt="">
                <div class="right-box">
                  <div class="right-title">{{$t('home.welcomeFireCat')}}</div>
                  <div class="right-text">{{$t('home.evolvingEcosystem')}}</div>
                  <a class="getapp right-btn" @click="showRegister = true" data-popup-id="arche-intro"  href="#" data-popup-focus-input="username">
                    <img src="../../assets/imgs/white_logo.png" alt="">
                    <div>{{$t('home.register')}}</div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Slide 2 -->
    <section class="slide slide2">
      <div class="content">
        <div class="container">
          <div class="wrap">
            <div class="left toLeft opener">
              <div class="info ae-2 fromLeft">
                <div class="middle-title">
                  <div>{{$t('home.whatFireCat')}}</div>
                  <img src="../../assets/imgs/red_logo.png" alt="logo">
                </div>
                <div class="middle-img-list-box">
                  <div class="middle-img-list" v-for="(item,index) in list" :key="index">
                    <img :src="item.img" alt="">
                    <div class="list-title">{{item.title}}</div>
                    <div class="list-text1">{{item.text1}}</div>
                    <div class="list-text2" v-if="item.text2">{{item.text2}}</div>
                    <div class="list-text3" v-if="item.text3">{{item.text3}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Slide 3 -->
    <section class="slide slide3">
      <div class="content">
        <div class="container">
          <div class="wrap">
            <div class="left toLeft opener">
              <div class="info ae-2 fromLeft">
                <div class="bottom-title">
                  <div>{{$t('home.roadmap')}}</div>
                  <img src="../../assets/imgs/map.png" alt="map">
                </div>
                <div class="bottom-line">
                  <img src="../../assets/imgs/line.png" alt="line">
                  <div class="bottom-box">
                    <div class="line-menu1">
                      <div class="line-title">{{$t('home.phase')}} 1</div>
                      <div class="line-round"></div>
                      <div class="line-text first">{{$t('home.websiteLaunch')}}</div>
                      <div class="line-text">{{$t('home.smartContractDeployment')}}</div>
                      <div class="line-text">{{$t('home.fairTokenLaunch')}}</div>
                      <div class="line-text">{{$t('home.airdropEvent')}}</div>
                    </div>
                    <div class="line-menu2">
                      <div class="line-title">{{$t('home.phase')}} 2</div>
                      <div class="line-round"></div>
                      <div class="line-text first">{{$t('home.whitepaperRelease')}}</div>
                      <div class="line-text">{{$t('home.nftOnline')}}</div>
                      <div class="line-text">{{$t('home.firecatNFTonline')}}</div>
                    </div>
                    <div class="line-menu3">
                      <div class="line-title">{{$t('home.phase')}} 3</div>
                      <div class="line-round"></div>
                      <div class="line-text first">{{$t('home.vaultsProtocolOnline')}}</div>
                      <div class="line-text">{{$t('home.nftLevelUpOnline')}}</div>
                      <div class="line-text">{{$t('home.moreNFTonline')}}</div>
                    </div>
                    <div class="line-menu4">
                      <div class="line-title">{{$t('home.phase')}} 4</div>
                      <div class="line-round"></div>
                      <div class="line-text first">{{$t('home.decentralizedDAOVotingSystem')}}</div>
                      <div class="line-text">{{$t('home.decentralizedExchange')}}</div>
                      <div class="line-text">{{$t('home.moreVaults')}}</div>
                      <div class="line-text">{{$t('home.supportMoreBlockChain')}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Slide 4 footer -->
    <section class="slide slide4">
      <div class="content">
        <div class="container">
          <div class="wrap">
            <div class="left toLeft opener">
              <div class="info ae-2 fromLeft">
                <div class="footer-left">
                  <img class="footer-logo" src="../../assets/imgs/logo.png" alt="">
                  <div class="footer-text">© 2022 FirecatFinance All rights reserved.</div>
                </div>
                <div class="footer-right">
                  <a href="https://twitter.com/Firecat_Finance?s=09">
                    <img src="../../assets/imgs/twitter.png" alt="twitter">
                  </a>
                  <a href="https://t.me/Firecatoffical">
                    <img src="../../assets/imgs/telegram.png" alt="telegram">
                  </a>
                  <a href="https://discord.gg/Z232yz23Rj">
                    <img src="../../assets/imgs/medium.png" alt="discord">
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Loading Progress Bar -->
    <div class="progress-bar blue"></div>

    <pop v-if="showPop" @back="back" />
    <register v-if="showRegister"  @back="backRegister" />
  </div>

</template>

<script>
  import { slidesFunction } from "../../utils/slidesTest";
  import pop from './pops.vue';
  import register from './register.vue';
  export default {
    name: "home",
    data() {
      return {
        showPop: false,
        showLang: false,
        showRegister: false,
      };
    },
    components: { pop, register },
    created() {
      document.title = "FIRECAT";
    },
    mounted() {
      setTimeout(() => {
        this.onCreateView();
      }, 100);
    },
    computed: {
      lan () {
        return this.$i18n.locale || 'en'
      },
      list () {
        return [
          { 
            img: require('../../assets/imgs/group_0.png'),
            title: 'Firecat NFT',
            text1: this.$t('home.nextNft'),
            text2: this.$t('home.multiBlockchain'),
            text3: this.$t('home.endlessPossibilites'),
          },
          { 
            img: require('../../assets/imgs/group_1.png'),
            title: this.$t('home.vaults'),
            text1: this.$t('home.bestStrategies'),
            text2: this.$t('home.highAPR'),
            text3: this.$t('home.highLiquidity'),
          },
          { 
            img: require('../../assets/imgs/group_2.png'),
            title: 'Firecat Pool',
            text1: this.$t('home.nextDEFImining'),
            text2: this.$t('home.combination'),
            text3: this.$t('home.continualReward'),
          },
          { 
            img: require('../../assets/imgs/group_3.png'),
            title: this.$t('home.dex'),
            text1: this.$t('home.swapAnything'),
            text2: this.$t('home.earnTradingFees'),
            text3: this.$t('home.noRegistration'),
          },
          { 
            img: require('../../assets/imgs/group_4.png'),
            title: 'DAO',
            text1: this.$t('home.communityGovernance'),
            text2: this.$t('home.proposal'),
            text3: this.$t('home.voting'),
          },
          { 
            img: require('../../assets/imgs/group_5.png'),
            title: this.$t('home.node'),
            text1: this.$t('home.earnReward'),
          },
        ]
      },
    },
    watch: {},
    destroyed() {
      this.removeHome();
    },
    methods: {
      setLan(str){
        localStorage.setItem('languageFirecat',str)
        this.$i18n.locale = str
      },
      back(){
        this.showPop = false;
      },
      backRegister(){
        this.showRegister = false;
      },
      onCreateView() {
        document.querySelector("body").classList.add("posr");
        slidesFunction();
        window.scrollTo(0, 1);
      },
      removeHome() {
        $("body").removeClass("posr");
        $(window).off("mousemove");
      },
    },
  };
</script>

<style lang="scss" scoped>
  .posr {
    position: relative;
  }
  [data-lang="cn"] {
    display: none;
  }
  html,
  body {
    background: #01101e;
  }
  .page-home2 {
    /* main-navi */
    background: #01101e;
    .slide {
      background: #01101e;
    }
    .sidebar {
      .logo {
        svg.shape {
          width: 32px;
          height: 32px;
        }
        svg.text {
          width: 128px;
          height: 28px;
        }
      }
    }
    .pole .navigation.default li {
      padding: 2px 0px;
    }

    .pole .navigation.default li:after {
      height: 30px;
      width: 2px;
      box-shadow: none;
    }

    .pole .navigation.default li.selected:after {
      height: 120px;
    }

    .pole .navigation.default li:hover:after {
      width: 5px;
    }

    /* Panel Top 04 */
    .panel {
      top: 0px;
      margin: 0 auto;
      background: #fff;
      padding: 0;
      filter: drop-shadow(0px 4px 12px rgba(0, 0, 0, 0.12));
      box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.12);
      .desktop {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 80px;
        max-width: 1049px;
        margin: 0 auto;
        &.hidden {
          display: none;
        }
        .home-menu{
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .left {
            width: 33.333%;
            display: flex;
            align-items: center;
            .logo {
              img {
                width: 146px;
                height: 32px;
              }
            }
          }
          .center {
            display: flex;
            .menu {
              li {
                margin: 0 20px;
                a {
                  font-family: "K2D";
                  font-weight: 700;
                  font-size: 20px;
                  line-height: 32px;
                  text-align: center;
                  color: #000000;
                  opacity: 1;
                  &:hover {
                    color: #EA4344;
                  }
                }
              }

              li:nth-child(1){
                a{
                  color: #EA4344;
                }
              }
            }
            .menu-lan{
              position: relative;
              .lan-text{
                display: flex;
                align-items: center;
                font-family: 'K2D';
                font-style: normal;
                font-weight: 700;
                font-size: 20px;
                color: #000;
                img{
                  width: 20px;
                  height: 20px;
                  margin-left: 10px;
                  margin-right: 54px;
                  cursor: pointer;
                  margin-top: 2px;
                }
                .active {
                  transform: rotate(180deg);
                  margin-top: 4px;
                }
              }
              .lan-list{
                width: 100px;
                position: absolute;
                top: 56px;
                color: #000;
                left: -20px;
                background: #FFFFFF;
                box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.14);
                border-radius: 16px;
                font-weight: 600;
                >div{
                  width: 100%;
                  text-align: center;
                  padding: 10px;
                  cursor: pointer;
                }
                .active{
                  color: #EA4344;
                }
              }
            }
          }
          .right {
            width: 33.333%;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            .lang-switch {
              svg {
                width: 26px;
                height: 20px;
                border-radius: 2px;
                overflow: hidden;
              }
              span {
                width: 32px;
                font-family: "K2D";
                font-weight: 600;
                font-size: 20px;
                line-height: 32px;
                text-align: center;
                margin-right: 5px;
              }
            }
            .getapp {
              width: 225px;
              height: 54px;
              font-family: "K2D";
              font-weight: bold;
              font-size: 20px;
              line-height: 54px;
              color: #ffffff;
              background: #EA4344;
              border-radius: 18px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-style: italic;
              img{
                width: 24px;
                height: 24px;
                margin-right: 10px;
              }
            }
          }
        }
        
      }
      .compact {
        height: 50px;
        padding: 5px 10px 5px 20px;
        position: relative;
        .left {
          display: flex;
          align-items: center;
          a.logo {
            display: block;
            width: 50%;
            svg.shape {
              width: 22px;
              height: 22px;
              display: inline;
            }
            svg.text {
              width: 120px;
              height: 22px;
              display: inline;
            }
          }
        }
        .right {
          right: 0;
          .button {
            display: block;
            width: 60px;
            padding: 12px 20px;
            background: none;
            border: none;
            box-shadow: none;
            margin-right: 0;
            float: right;
            svg {
              width: 20px;
              height: 20px;
              fill: #fff !important;
            }
          }
        }
      }
    }
    .dropdown.translate,
    .dropdown.community {
      width: 180px;
      li {
        width: 100%;
        padding: 10px;
        cursor: pointer;
        a {
          width: 100%;
          font-family: "CocogooseP";
          font-weight: 600;
          font-size: 20px;
          line-height: 48px;
          text-align: center;
          color: #000;
          opacity: 1;
        }
        &:hover {
          background: rgba(0, 0, 0, 0.05);
          a {
            color: #0116ff;
          }
        }
      }
    }

    /* Slide 1 */
    .slide1 {
      background: #fff;
      color: #000;
      .wrap{
        background: linear-gradient(180deg, #FBE9E5 0%, rgba(255, 255, 255, 0) 100%);
        padding-left: 0;
        padding-right: 0;
      }
      .info{
        max-width: 1049px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        padding-top: 54px;
        .left-img{
          width: 328px;
          height: 442px;
        }
        .right-box{
          width: 600px;
          .right-title{
            font-family: 'K2D';
            font-weight: 800;
            font-size: 70px;
            line-height: 84px;
            text-align: left;
          }
          .right-text{
            font-family: 'Tomorrow';
            font-weight: 400;
            font-size: 20px;
            line-height: 200%;
            margin-top: 20px; 
            text-align: left;
          }
          .right-btn{
            width: fit-content;
            height: 54px;
            margin-top: 70px;
            background: #EA4344;
            border-radius: 18px;
            padding: 0 26px;
            display: flex;
            align-items: center;
            img{
              width: 24px;
              height: 24px;
              margin-right: 10px;
            }
            div{
              font-style: italic;
              text-transform: uppercase;
              font-weight: 800;
              font-size: 20px;
              color: #fff;
            }
          }
        }
      }
    }

    /* Slide 2 */
    /* easeOutCubic */
    //////////////////////////////
    // Coverflow styles
    //////////////////////////////
    $imageW: 400px;
    $imageH: 555px;

    $transitionSpeed: 350ms;
    $transitionEasing: cubic-bezier(0.215, 0.61, 0.355, 1); /* easeOutCubic */

    $nonfocusSpacing: 160px;
    $focusMargin: 220px;
    $maxNonfocusOpacity: 0.9;
    $maxNonfocusScale: 0.6;
    $minNonfocusScale: 0.3;
    $numNonfocusVisible: 3;

    $centerGlow: 0 1px 25px 10px rgba(#000000, 0.15);
    $perspective: 1000px;
    $leftTransform: rotateY(15deg);
    $rightTransform: rotateY(-15deg);

    $maxImages: 5;

    // Main Styles
    .coverflow {
      position: relative;
      box-sizing: content-box;
      height: $imageH;
      padding: 30px 0;
      perspective: $perspective;

      &__image {
        user-select: none;
        width: $imageW;
        height: $imageH;
        transition: all $transitionSpeed $transitionEasing;
        border-radius: 12px;
        position: relative;
        a {
          width: 32px;
          height: 32px;
          position: absolute;
          bottom: 36px;
          right: 30px;
          z-index: 9;
          svg {
            width: 32px;
            height: 32px;
          }
        }
        &[data-coverflow-index] {
          position: absolute;
          left: 50%;
          transform-origin: 50% 50%;
          &:before {
            content: " ";
            z-index: 1;
            position: absolute;
            top: 0px;
            width: 100%;
            height: 100%;
            border-radius: 12px;
            box-shadow: 0 0 30px rgba(#000000, 0.2);
          }
        }
      }

      @for $x from 1 through $maxImages {
        &[data-coverflow-position="#{$x}"] {
          @for $y from 1 through $maxImages {
            @if ($y < $x) {
              //left
              $dist: $x - $y;
              .coverflow__image[data-coverflow-index="#{$y}"] {
                z-index: $maxImages - $dist;
                $scale: (
                    (
                        ($maxNonfocusScale - $minNonfocusScale) /
                          ($numNonfocusVisible - 1)
                      ) *
                      ($numNonfocusVisible - ($dist - 1))
                  ) +
                  $minNonfocusScale;
                $translateX: (-1 * $nonfocusSpacing * ($dist - 1)) -
                  ($imageW / 2) -
                  $focusMargin;
                transform: translateX($translateX) scale($scale) $leftTransform;
                // opacity: ($maxNonfocusOpacity / $numNonfocusVisible) *
                //   ($numNonfocusVisible - ($dist - 1.5));
                opacity: (($maxImages - $dist) / 8 * 2);
                filter: blur($dist * 1px);
              }
            }
            @if ($y == $x) {
              //center (focus)
              .coverflow__image[data-coverflow-index="#{$y}"] {
                z-index: $maxImages;
                transform: translateX(-1 * ($imageW / 2));
                box-shadow: $centerGlow;
              }
            }
            @if ($y > $x) {
              //right
              $dist: $y - $x;
              .coverflow__image[data-coverflow-index="#{$y}"] {
                z-index: $maxImages - $dist;
                $scale: (
                    (
                        ($maxNonfocusScale - $minNonfocusScale) /
                          ($numNonfocusVisible - 1)
                      ) *
                      ($numNonfocusVisible - ($dist - 1))
                  ) +
                  $minNonfocusScale;
                $translateX: ($nonfocusSpacing * ($dist - 1)) -
                  ($imageW / 2) +
                  $focusMargin;
                transform: translateX($translateX) scale($scale) $rightTransform;
                // opacity: ($maxNonfocusOpacity / $numNonfocusVisible) *
                //   ($numNonfocusVisible - ($dist - 1));
                opacity: (($maxImages - $dist) / 8 * 2);
                filter: blur($dist * 1px);
              }
            }
          }
        }
      }
    }

    // Arrows
    .next-arrow,
    .prev-arrow {
      cursor: pointer;
      z-index: 10;
      position: absolute;
      top: 46%;
      img {
        width: 80px;
        height: 80px;
      }
      &:hover,
      &:focus {
        color: rgba(0, 0, 0, 0.5);
      }
    }
    .prev-arrow {
      left: 0;
    }
    .next-arrow {
      right: 0;
    }

    /* Slide 2 */
    .slide2 {
      background: #fff;
      color: #000;

      .wrap{
        padding: 0;
      }
      .info{
        max-width: 1049px;
        margin: 0 auto;
        padding-top: 100px;
        .middle-title{
          position: relative;
          font-weight: 800;
          font-size: 60px;
          line-height: 84px;
          text-align: center;
          font-family: 'K2D';
          div{
            width: 100%;
          }
          img{
            width: 56px;
            height: 56px;
            position: absolute;
            left: calc(50% - 42px);
            top: -10px;
            transform: rotate(15.63deg);
          }
        }
        .middle-img-list-box{
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          margin-top: 80px;
          .middle-img-list{
            margin-left: 79px;
            margin-bottom: 24px;
            img{
              width: 280px;
              height: 250px;
            }
            .list-title{
              font-weight: 800;
              font-size: 32px;
              font-family: 'K2D';
              margin-top: -18px;
              padding-left: 15px;
            }
            .list-text1{
              margin-top: 13px;
            }
            .list-text1,.list-text2,.list-text3{
              font-family: 'K2D';
              font-style: normal;
              font-weight: 400;
              font-size: 16px;
              line-height: 160%;
              padding-left: 15px;
              width: 258px;
            }
          }
          .middle-img-list:nth-child(1){
            .list-title{
              color: #EA4344;
            }
          }
          .middle-img-list:nth-child(2){
            .list-title{
              color: #007DFF;
            }
          }
          .middle-img-list:nth-child(3){
            .list-title{
              color: #00DF0D;
            }
          }
          .middle-img-list:nth-child(4){
            .list-title{
              color: #007DFF;
              margin-top: -38px;
            }
          }
          .middle-img-list:nth-child(5){
            .list-title{
              color: #00DF0D;
              margin-top: -38px;
            }
          }
          .middle-img-list:nth-child(6){
            .list-title{
              color: #EA4344;
              margin-top: -38px;
            }
          }
          .middle-img-list:nth-child(1),.middle-img-list:nth-child(4){
            margin-left: 0;
          }
        }
      }
    }

    /* Slide 3 */
    .slide3 {
      background: #fff;
      color: #000;
      .wrap{
        padding: 0;
      }
      .info{
        max-width: 1049px;
        margin: 0 auto;
        .bottom-title{
          position: relative;
          font-family: 'K2D';
          font-style: normal;
          font-weight: 800;
          font-size: 60px;
          line-height: 84px;
          text-align: center;
          div{
            width: 100%;
          }
          img{
            width: 140px;
            height: 140px;
            position: absolute;
            left: calc(50% - 27px);
            top: -68px;
          }
        }
        .bottom-line{
          margin-top: 140px;
          position: relative;
          .bottom-box{
            width: 100%;
            position: absolute;
            top: 99px;
            left: 0;
            display: flex;
            justify-content: space-between;
            .line-menu1,.line-menu2,.line-menu3,.line-menu4{
              width: 25%;
              text-align: center;
              color: #007DFF;
              margin-top: -20px;
              .line-title{
                font-family: 'K2D';
                font-weight: 800;
                font-size: 26px;
                line-height: 100%;
                margin-bottom: 20px;
              }
              .line-round{
                width: 38px;
                height: 38px;
                background: #007DFF;
                border-radius: 100%;
                margin: 0 auto;
              }
              .line-text{
                font-family: 'K2D';
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                line-height: 160%;
              }
              .first{
                margin-top: 13px;
              }
            }
            .line-menu2{
              margin-top: -107px;
              color: #00DFB7;
              .line-title{
                margin-bottom: 27px;
              }
              .line-round{
                background: #00DFB7;
              }
              .first{
                margin-top: 27px;
              }
            }
            .line-menu3{
              margin-top: -156px;
              color: #00DF0D;
              .line-title{
                margin-bottom: 18px;
              }
              .line-round{
                background: #00DF0D;
              }
              .first{
                margin-top: 26px;
              }
            }
            .line-menu4{
              margin-top: -127px;
              color: #EB4445;
              .line-title{
                margin-bottom: 22px;
              }
              .line-round{
                background: #EB4445;
              }
              .first{
                margin-top: 22px;
              }
            }
          }
        }
      }
    }

    /* Slide 3 */
    .slide4 {
      background: #fff;
      color: #000;
      .container{
        height: 40px;
        .wrap{
          padding: 20px 0 89px 0;
        }
      }
      .info{
        max-width: 1049px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 40px;
        .footer-left{
          display: flex;
          align-items: center;
          .footer-logo{
            width: 183px;
            height: 40px;
          }
          .footer-text{
            margin-left: 40px;
            font-family: 'K2D';
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            color: rgba(0, 0, 0, .3);
          }
        }
        .footer-right{
          display: flex;
          justify-content: space-between;
          a{
            img{
              width: 40px;
              height: 40px;
              margin-left: 32px;
            }
          }
        }
      }
    }

    .lastSlide .panel.defaultPanel {
      transform: translateY(100px);
    }
    .lastSlide .panel.defaultPanel {
      transform: translateY(100px);
    }

    .scrollBox {
      position: fixed;
      width: 2px;
      height: 80px;
      overflow: hidden;
      bottom: 100px;
      right: 55px;
      border-radius: 2px;
    }
    .scrollBox:after {
      content: "";
      position: absolute;
      top: -80px;
      height: 80px;
      width: 2px;
      border-radius: 2px;
      background: #ffffff;
      animation: scrollDrive 2s ease infinite;
    }

    @keyframes scrollDrive {
      0% {
        top: -80px;
      }
      50% {
        top: 80px;
      }
      100% {
        top: 80px;
      }
    }

    .vertical-text {
      font-family: "CocogooseP";
      font-weight: 300;
      margin: 0 auto 2em;
      width: 0;
      position: fixed;
      letter-spacing: 0.5px;
      left: 54px;
      bottom: 60px;
      font-size: 9px;
      text-transform: uppercase;
      transform: rotate(90deg);
    }
    .panel.bottom {
      margin-bottom: 10px;
      .sections {
        justify-content: center;
      }
      .center {
        font-family: "CocogooseP";
        font-weight: 600;
        font-size: 20px;
        line-height: 50px;
        text-transform: uppercase;
        text-align: center;
      }
      .right {
        padding-right: 20px;
        svg {
          width: 40px;
          height: 40px;
          margin-left: 20px;
        }
      }
    }
  }
  .dg {
    display: none;
  }
</style>